import { CashflowModelsSection } from 'src/cashflows/modelling/CashflowModelsSection';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { NameFormat, formatName } from 'src/utils/nameFormatting';
import { FamilyCashflowsRedesign } from './FamilyCashflowsRedesign';
import { FamilyMember } from './useFamilyMembers';

export function FamilyCashflowPanel({
  familyId,
  members,
}: {
  familyId: string;
  members: FamilyMember[];
}) {
  const { flagEnabledCashflowModelling, flagEnabledFamilyCashflowModelling } = useFlags();
  const showModels = flagEnabledCashflowModelling && flagEnabledFamilyCashflowModelling;
  const selectableMembers = members.map(member => ({
    clientId: member.clientId,
    name: formatName(member.client.firstName, member.client.lastName, NameFormat.NATURAL),
  }));
  const modelsSection = showModels ? (
    <CashflowModelsSection scope={{ kind: 'family', id: familyId }} members={selectableMembers} />
  ) : null;

  return <FamilyCashflowsRedesign members={members} modelsSection={modelsSection} />;
}
